/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../app/store'
import { User } from './types';

// Define a type for the slice state
interface UserState {
    user: User | undefined;
    locked: boolean;
    isLoggedIn: boolean;
    isLoading: boolean;
    error: unknown;
    showPaymentModal: boolean;
    promptTimeout: number;
    lastPath: string | null;
    theme: string | null;
    announcements: string[];
    total_spot_balance: string;
    total_funding_balance: string;
    language: string
}

const initialState: UserState = {
    user: undefined,
    locked: false,
    isLoggedIn: false,
    isLoading: false,
    error: null,
    showPaymentModal: false,
    promptTimeout: 90,
    lastPath: null,
    theme: null,
    announcements: [],
    total_spot_balance: '',
    total_funding_balance: '',
    language: 'en'
}


export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        authenticate: (state, action: PayloadAction<any>) => {
            state.user = action.payload
            state.isLoggedIn = true
            state.isLoading = false
            state.error = null
        },
        signOut: (state) => {
            state.user = undefined
            state.isLoggedIn = false
            state.isLoading = false
            state.error = null
            state.announcements = []
        },
        lock: (state) => {
            state.locked = true
            state.isLoggedIn = false
            state.isLoading = false
            state.error = null
        },
        unlock: (state) => {
            state.locked = false
            state.isLoggedIn = false
            state.isLoading = false
            state.error = null
        },
        setShowPaymentModal: (state, action: PayloadAction<boolean>) => {
            state.showPaymentModal = action.payload
        },
        setPromptTimeout: (state, action: PayloadAction<number>) => {
            state.promptTimeout = action.payload
        },
        resetPromptTimeout: (state) => {
            state.promptTimeout = 90
        },
        setLastPath: (state, action: PayloadAction<string>) => {
            state.lastPath = action.payload
        },
        setTheme: (state, action: PayloadAction<string>) => {
            state.theme = action.payload
        },
        setAnnouncement: (state, action: PayloadAction<string[]>) => {
            state.announcements = action.payload
        },
        setTotalSpotBalance: (state, action: PayloadAction<string>) => {
            state.total_spot_balance = action.payload
        },
        setTotalFundingBalance: (state, action: PayloadAction<string>) => {
            state.total_funding_balance = action.payload
        },
        setLanguage: (state, action: PayloadAction<string>) => {
            state.language = action.payload
        }
    },
})

// export const { increment, decrement, incrementByAmount } = userSlice.actions
export const { authenticate, signOut, lock, unlock, setShowPaymentModal, setPromptTimeout, resetPromptTimeout, setLastPath, setTheme, setAnnouncement, setTotalSpotBalance, setTotalFundingBalance, setLanguage } = userSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectUser = (state: RootState) => state?.user

export default userSlice.reducer